import React from 'react';
import { BellIcon, SearchIcon, MenuIcon, UserIcon } from 'lucide-react';
interface HeaderProps {
  toggleSidebar: () => void;
  sidebarOpen: boolean;
}
export const Header: React.FC<HeaderProps> = ({
  toggleSidebar,
  sidebarOpen
}) => {
  return <header className="bg-white shadow-sm z-10 border-b border-gray-100" data-id="element-17">
      <div className="px-4 sm:px-6 py-4 flex items-center justify-between" data-id="element-18">
        <div className="flex items-center" data-id="element-19">
          <button onClick={toggleSidebar} className="md:hidden p-2 rounded-md text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none" data-id="element-20">
            <MenuIcon size={20} data-id="element-21" />
          </button>
          <div className="relative ml-4 md:ml-0" data-id="element-22">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-23">
              <SearchIcon size={18} className="text-gray-400" data-id="element-24" />
            </span>
            <input type="text" placeholder="Search..." className="pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent w-full md:w-64 bg-gray-50 hover:bg-white transition-colors duration-200" data-id="element-25" />
          </div>
        </div>
        <div className="flex items-center space-x-4" data-id="element-26">
          <button className="p-2 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none relative" data-id="element-27">
            <BellIcon size={20} data-id="element-28" />
            <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white" data-id="element-29"></span>
          </button>
          <div className="relative" data-id="element-30">
            <button className="flex items-center space-x-2 p-1.5 rounded-lg text-gray-700 hover:bg-gray-100 focus:outline-none" data-id="element-31">
              <div className="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center text-indigo-700" data-id="element-32">
                <UserIcon size={18} data-id="element-33" />
              </div>
              <span className="hidden md:inline text-sm font-medium" data-id="element-34">
                Admin
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>;
};